export default class BcpModal extends HTMLAnchorElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.watchers();
    }

    watchers() {
        this.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            window.HegydCore.initRemoteModal(
                '#modal',
                this.href,
                null,
                (data) => {
                    if(data.hasOwnProperty('update')){
                        toastr.success('Budget Commercial Promotion <br/>mis à jour');
                    }else{
                        toastr.success('Nouveau Budget Commercial Promotion créé');
                    }

                    $('.list-bcp').html(data.view);
                },
                () => {
                    toastr.error('Une erreur s\'est produite');
                },
            );
        });
    }
}
